
  (function(){
    const toc = document.getElementById('toc');
    const tocBar = document.getElementById('tocBar');
    const links = Array.from(document.querySelectorAll('.toc__link'));
    const sections = links.map((a, idx) => {
      const target = document.querySelector(a.getAttribute('href'));
      if (target) {
        target.dataset.tocIndex = idx;
      }
      return target;
    }).filter(Boolean);
    const hero = document.getElementById('k13-lite-get-the-best-price');
    const hideSection = document.getElementById('k13-lite-parameter-table');
    let isProgrammaticScroll = false; // 点击锚点触发的平滑滚动期间，抑制进度条抖动
    let programmaticTimer = null;
    let heroBottom = 0;
    let hideSectionBottom = 0;
    let visibilityScheduled = false;

    if (!toc || !tocBar || !links.length || !hero || !hideSection) {
      return;
    }

    const calculateBounds = () => {
      const scrollY = window.scrollY;
      const heroRect = hero.getBoundingClientRect();
      const hideRect = hideSection.getBoundingClientRect();
      heroBottom = scrollY + heroRect.bottom - 1;
      hideSectionBottom = scrollY + hideRect.bottom;
    };

    const updateTocVisibility = () => {
      visibilityScheduled = false;
      const scrollY = window.scrollY;
      const windowBottom = scrollY + window.innerHeight;
      const show = scrollY >= heroBottom && windowBottom < hideSectionBottom - 10;
      toc.classList.toggle('toc--show', show);
    };

    const scheduleVisibilityUpdate = () => {
      if (visibilityScheduled) return;
      visibilityScheduled = true;
      requestAnimationFrame(updateTocVisibility);
    };

    // 点击平滑跳转（进一步确保 offset 定位）
    links.forEach((a, idx) => {
      a.addEventListener('click', (e) => {
        e.preventDefault();
        const target = sections[idx];
        if (!target) return;

        isProgrammaticScroll = true;
        if (programmaticTimer) {
          clearTimeout(programmaticTimer);
        }
        programmaticTimer = setTimeout(() => {
          isProgrammaticScroll = false;
        }, 900);

        if ('onscrollend' in window) {
          const off = () => {
            isProgrammaticScroll = false;
            window.removeEventListener('scrollend', off, { once:true });
          };
          window.addEventListener('scrollend', off, { once:true });
        }

        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        setActiveByIndex(idx);
        setProgressByIndex(idx);
      }, { passive: false });
    });

    // 设置激活态
    function setActiveByIndex(activeIdx){
      links.forEach((a, i) => a.classList.toggle('is-active', i === activeIdx));
    }

    // 设置进度（按区块序号线性映射到 0%~100%）
    function setProgressByIndex(idx){
      if (sections.length < 2) return;
      const pct = idx / (sections.length - 1);
      tocBar.style.height = (pct * 100) + '%';
    }

    // 使用 IntersectionObserver 根据滚动自动高亮与进度
    const io = new IntersectionObserver((entries) => {
      if (isProgrammaticScroll) return; // 在平滑滚动时忽略 IO 回调，避免进度条伸缩
      let best = { idx: -1, ratio: 0 };
      for (const entry of entries) {
        const idx = Number(entry.target.dataset.tocIndex);
        if (Number.isFinite(idx) && entry.intersectionRatio > best.ratio) {
          best = { idx, ratio: entry.intersectionRatio };
        }
      }
      if (best.idx >= 0) {
        setActiveByIndex(best.idx);
        setProgressByIndex(best.idx);
      }
    }, {
      root: null,
      threshold: buildThresholds(10),
      rootMargin: '-15% 0px -15% 0px',
    });

    sections.forEach(sec => io.observe(sec));

    calculateBounds();
    updateTocVisibility();
    window.addEventListener('scroll', scheduleVisibilityUpdate, { passive:true });
    window.addEventListener('resize', () => {
      calculateBounds();
      scheduleVisibilityUpdate();
    }, { passive:true });

    // 工具：生成 0..1 的 thresholds
    function buildThresholds(steps){
      const t = [];
      for (let i = 0; i <= steps; i++) {
        t.push(i / steps);
      }
      return t;
    }
  })();
